module.exports = __webpack_public_path__ + "media/images/4-quart-ebd5224478e49fd0f3fe2f832d109c03.png";